export const SET_USER = 'SET_USER'
export const BUSY_ON = 'BUSY_ON'
export const BUSY_OFF = 'BUSY_OFF'
export const SERVICE_READY = 'SERVICE_READY'
export const SET_HEADER_ACTIONS = 'SET_HEADER_ACTIONS'
